import { validate, v4 } from "uuid"
import { Brand } from "./helpers"

export type Uuid = Brand<string, "Uuid">

export function createUuid(): Uuid {
  return v4() as Uuid
}

// True only for canonical UUID strings. Used to tell a real instance id (always a generated UUID)
// from a legacy slug dashboard id (a human-typed route segment like "default" or "my-portfolio").
export function isUuid(value: unknown): value is Uuid {
  return typeof value === "string" && validate(value)
}

export function assertUuid(uuid: unknown): asserts uuid is Uuid {
  if (typeof uuid !== "string" || !validate(uuid)) {
    throw Error(`Invalid UUID: ${uuid}`)
  }
}

export function assertUuidOrNull(uuid: unknown): asserts uuid is Uuid | null {
  if (uuid !== null) {
    assertUuid(uuid)
  }
}
